const initialState = {
  app: {
    baselineShown: false,
    currentTheme: 'danyOneDefaultTheme',
    error: null,
    menuShown: false,
    mobileTitle: '',
    floatingTvRemoteShown: false,
    online: false,
    storageIsReady: false,
    carousels: {},
    activeReceiver: undefined,
    changeReceiverError: false,
    viewport: undefined,
  },
  auth: {
    formDisabled: false,
    error: undefined,
    viewer: undefined,
    signInType: 'none',
    redirectToLogout: false,
  },
  config: {
    adapt: {
      url: 'https://orange.adProxy.dishtechbeta.us/',
    },
    bitmovin: {
      player_key: 'ba76e73c-3802-4daa-982b-570843ab82fc',
      qvt_proxy_url: 'https://qvt-proxy.dishanywhere.com',
      qvt_proxy_enabled: true,
    },
    nielsen: {
      enabled: true,
      sfcode: 'DCR-CERT',
      apid: 'T5F852D9D-ED4B-4040-8DCF-2132127FD722',
      apn: 'test-setup',
      nol_sdkDebug: 'console',
    },
    reporting: {
      reporting_enabled: false,
      bugsnag_api_key: '697f6bb151617cb7091537dda7f8134f',
      bugsnag_rn_api_key: '598d23dde21ed1e6234bf159df30d6ce',
      fullstory_enabled: false,
      google_analytics_id: 'UA-145700416-4',
    },
    session: { ...process.env.config },
    base: {
      env: 'production',
    },
    appName: 'DanyOne',
    appVersion: '',
  },
  device: {
    host: '',
    deviceId: '',
    deviceName: '',
    deviceOs: '',
    clientIp: '',
  },
  dvr: {
    recordings: {
      content: [],
      error: false,
      fetching: false,
      filters: null,
    },
    timers: {
      content: [],
      fetching: false,
      error: false,
      loaded: false,
    },
    scheduled: {
      content: [],
      fetching: false,
      error: false,
    },
    recordedAirings: [],
    recordingsDetails: {
      content: [],
      fetching: false,
      error: false,
    },
    deletedRecordings: [],
    deleteRecording: {
      fetching: false,
      error: false,
    },
    createTimer: {
      fetching: false,
      error: false,
      content: {},
      pendingCreate: [],
    },
    updating: {
      fetching: false,
      error: false,
      pendingUpdate: [],
    },
    deleteTimer: {
      fetching: false,
      error: false,
      pendingRemoval: [],
    },
    deletedTimers: [],
    skippingOrRestoring: {
      fetching: false,
      error: false,
    },
    setError: false,
    dvrUsageInPercents: undefined,
    fetchingReceiverStatus: false,
    dataGeneration: 0,
  },
  est: {
    error: false,
    fetching: false,
    cards: [],
    selectedCard: {
      last_four: '',
      expiration_date: '',
      card_type: '',
      id: null,
    },
    pricingInfo: {
      pricing_plans: [],
      product_id: null,
    },
    purchasedContentId: null,
    purchaseSucceeded: false,
    purchases: {
      error: false,
      fetching: false,
      content: [],
    },
    purchasesCount: 0,
    estAuthorizedDevices: {
      fetching: false,
      error: false,
      devices: [],
    },
    removeDevice: {
      currentlyRemovingDevices: [],
      errorDescription: '',
    },
    viewContent: {
      error: false,
      fetching: false,
      content: undefined,
    },
    updateContentProgress: {
      error: false,
      fetching: false,
      content: undefined,
    },
    currentFilters: null,
    currentSort: 'purchaseDate',
  },
  franchise: {
    franchiseSlug: null,
    linkContent: false,
    showContent: false,
    recommendations: {
      fetching: false,
      content: [],
      error: false,
    },
    franchiseDetails: {
      fetching: false,
      error: false,
      requireRefresh: false,
      bySlug: {},
    },
    recentlyWatchedContentId: null,
  },
  guide: {
    // activeContent: {},
    startTime: '',
    endTime: '',
    channelSection: [],
    content: {
      available_count: 0,
      channel_airings: [],
    },
    fetchingAirings: false,
    fetchingChannels: false,
    fetchingFavorites: false,
    fetchingLiveLinearChannelsError: false,
    liveLinearChannelsError: false,
    error: false,
    channels: {},
    channelError: false,
    channelList: [],
    channelListStale: false,
    favorites: [],
    favoritesFetched: false,
    favoritesError: false,
    fetchingLiveLinearChannels: false,
    liveLinearChannels: {
      available_count: 0,
      channel_airings: {},
    },
    activeContent: {
      available_count: 0,
      channel_airings: {},
    },
    openAiring: {},
    openChannel: {},
    openAiringId: '',
    expandedChannels: [],
    expandedChannelGroup: [],
    currentTime: null,
    currentTimeSelection: 'Today',
    currentFilter: 'All Channels',
    currentGuideType: 'all',
    currentSearchTerm: '',
    timerCreatedDisplay: false,
  },
  intl: {
    currentLocale: 'en',
    defaultLocale: 'en',
    initialNow: 1572433664315,
    locales: ['cs', 'de', 'en', 'es', 'fr', 'pt', 'ro'],
    messages: {
      cs: {
        'app.buttons.add': 'Přidat',
        'app.buttons.cancel': 'Zrušit',
        'app.buttons.delete': 'Smazat',
        'app.buttons.dismiss': 'Zrušit',
        'app.buttons.edit': 'Editovat',
        'app.buttons.save': 'Uložit',
        'app.buttons.signIn': 'Přihlášení',
        'app.buttons.signOut': 'Odhlásit se',
        'app.buttons.signUp': 'Registrace',
        'app.buttons.submit': 'Odeslat',
        'app.confirm.areYouSure': 'Jste si jistý?',
        'app.confirm.unsavedChanges': 'Máte neuložené změny. Jste si jistý?',
        'app.links.home': 'Úvod',
        'app.links.intl': 'Lokalizace',
        'app.links.signOut': 'Odhlásit se',
        'app.links.notFound': 'Stránka nenalezena',
        'app.links.offline': 'Offline',
        'app.links.profile': 'Profil',
        'app.links.settings': 'Nastavení',
        'app.links.signIn': 'Přihlášení',
        'app.links.users': 'Uživatelé',
        'app.links.guide': 'Průvodce',
        'auth.email.emailLegend': 'Email',
        'auth.email.emailPlaceholder': 'tvuj@email.com',
        'auth.email.passwordForgotten': 'Zapomenuté heslo',
        'auth.email.passwordPlaceholder': 'heslo',
        'auth.email.passwordRecoveryLegend': 'Obnovení hesla',
        'auth.email.recoveryEmailSent': 'Email pro obnovení hesla odeslán.',
        'auth.email.resetPassword': 'Reset hesla',
        'auth.signInError.email': 'Emailová adresa není správná.',
        'auth.signInError.required':
          'Prosím vyplňte {prop, select, email {email} password {heslo}}.',
        'auth.signInError.simplePassword': 'Heslo musí obsahovat alespoň {minLength} znaků.',
        'auth.social.facebookSignIn': 'Přihlášení přes Facebook',
        'footer.madeByHtml': 'stvořil',
        'intl.page.unreadCount': '{unreadCount, plural, one {zpráva} other {zpráv}}',
        'loading.loadingText': 'Nahrávám',
        'loading.longLoadingText': 'Stále nahrávám...',
        'notFound.continue': 'Pokračujte zde prosím.',
        'notFound.h1': 'Tato stránka není dostupná',
        'notFound.p': 'Možná máte špatný odkaz, nebo byla stránka odstraněna.',
        'firebase.error.auth/network-request-failed': '',
        'firebase.error.auth/too-many-requests': '',
        'firebase.error.auth/user-token-expired': '',
        'firebase.error.EMAIL_TAKEN': '',
        'firebase.error.INVALID_EMAIL': '',
        'firebase.error.INVALID_PASSWORD': '',
        'firebase.error.INVALID_USER': '',
        'app.links.authorized_devices': '',
        'app.links.back': '',
        'app.links.closed_captioning': '',
        'app.links.dev': '',
        'app.links.dvr': '',
        'app.links.feedback': '',
        'app.links.live_tv': '',
        'app.links.my_purchases': '',
        'app.links.on_demand': '',
        'app.links.parental_controls': '',
        'app.links.pay_my_bill': '',
        'app.links.preferences': '',
        'app.links.sports': '',
        'app.links.transfers': '',
        'app.links.tv_remote': '',
        'app.links.watchlist': '',
      },
      de: {
        'app.buttons.add': 'Hinzufügen',
        'app.buttons.cancel': 'Abbrechen',
        'app.buttons.delete': 'Löschen',
        'app.buttons.dismiss': 'Entlassen',
        'app.buttons.edit': 'Bearbeiten',
        'app.buttons.save': 'Speichern',
        'app.buttons.signIn': 'Anmelden',
        'app.buttons.signOut': 'Abmelden',
        'app.buttons.signUp': 'Anmelden',
        'app.buttons.submit': 'Senden',
        'app.confirm.areYouSure': 'Sind Sie sicher?',
        'app.confirm.unsavedChanges': 'Sie haben Änderungen gemacht. Sind Sie sicher?',
        'app.links.home': 'Homepage',
        'app.links.intl': 'Übersetzung',
        'app.links.signOut': 'Abmelden',
        'app.links.notFound': 'Seite nicht gefunden',
        'app.links.offline': 'Offline',
        'app.links.profile': 'Profil',
        'app.links.settings': 'Einstellungen',
        'app.links.signIn': 'Anmelden',
        'app.links.users': 'Benutzer',
        'app.links.guide': 'Fernsehprogramm',
        'auth.email.emailLegend': 'E-Mail',
        'auth.email.emailPlaceholder': 'ihre@email.com',
        'auth.email.passwordForgotten': 'Passwort vergessen?',
        'auth.email.passwordPlaceholder': 'Passwort',
        'auth.email.passwordRecoveryLegend': 'Passwort zurücksetzen',
        'auth.email.recoveryEmailSent':
          'Die E-Mail zum Zurücksetzen Ihres Passwortes wurde gesendet.',
        'auth.email.resetPassword': 'Passwort zurücksetzen',
        'auth.signInError.email': 'Diese E-Mail Adresse ist nicht gültig.',
        'auth.signInError.required':
          'Bitte füllen Sie das Feld {prop, select, email {Email} password {Passwort}} aus.',
        'auth.signInError.simplePassword':
          'Das Passwort muss mindestens {minLength} Zeichen lang sein.',
        'auth.social.facebookSignIn': 'Anmeldung via Facebook',
        'firebase.error.EMAIL_TAKEN':
          'Das Konto konnte nicht erstellt werden, weil die E-Mail bereits benutzt wurde.',
        'firebase.error.INVALID_EMAIL': 'Die angegebene E-Mail ist nicht gültig.',
        'firebase.error.INVALID_PASSWORD': 'Das eingegebene Passwort ist falsch für dieses Konto.',
        'firebase.error.INVALID_USER': 'Das eigegebene Konto existiert nicht.',
        'footer.madeByHtml': 'Umgesetzt von',
        'intl.page.unreadCount': '{unreadCount, plural, one {Meldung} other {Meldungen}}',
        'loading.loadingText': 'Laden',
        'loading.longLoadingText': 'Noch Laden, überprüfen Sie bitte Ihre Verbindung',
        'notFound.continue': 'Hier weiter bitte',
        'notFound.h1': 'Diese Seite existiert nicht.',
        'notFound.p': 'Der Link ist möglicherweise veraltet oder die Seite wurde gelöscht.',
        'firebase.error.auth/network-request-failed': '',
        'firebase.error.auth/too-many-requests': '',
        'firebase.error.auth/user-token-expired': '',
        'app.links.authorized_devices': '',
        'app.links.back': '',
        'app.links.closed_captioning': '',
        'app.links.dev': '',
        'app.links.dvr': '',
        'app.links.feedback': '',
        'app.links.live_tv': '',
        'app.links.my_purchases': '',
        'app.links.on_demand': '',
        'app.links.parental_controls': '',
        'app.links.pay_my_bill': '',
        'app.links.preferences': '',
        'app.links.sports': '',
        'app.links.transfers': '',
        'app.links.tv_remote': '',
        'app.links.watchlist': '',
      },
      es: {
        'app.links.dev': 'Desarrollo',
        'app.links.preferences': 'Preferencias',
        'app.links.back': 'Espalda',
        'app.links.home': 'Inicio',
        'app.links.guide': 'Guía',
        'app.links.watchlist': 'Mi lista',
        'app.links.dvr': 'DVR',
        'app.links.on_demand': 'Vídeo a la carta',
        'app.links.my_purchases': 'Mis compras',
        'app.links.sports': 'Deportes',
        'app.links.live_tv': 'TV en directo',
        'app.links.transfers': 'Transferencias',
        'app.links.tv_remote': 'Remoto de TV',
        'app.links.signIn': 'Iniciar Sesión',
        'app.links.signOut': 'Cerrar Sesión',
        'app.links.pay_my_bill': 'Pagar mi factura',
        'app.links.parental_controls': 'Controles parentales',
        'app.links.authorized_devices': 'Dispositivos autorizados',
        'app.links.closed_captioning': 'Subtítulos',
        'app.links.feedback': 'Comentario',
        'app.links.notFound': 'Página no encontrada',
        'app.links.intl': 'Idioma',
        'app.links.users': 'Usuarios',
        'app.links.offline': 'Desconectado',
        'app.links.profile': 'Perfil',
        'app.links.settings': 'Ajustes',
        'app.buttons.add': 'Añadir',
        'app.buttons.cancel': 'Cancelar',
        'app.buttons.delete': 'Borrar',
        'app.buttons.dismiss': 'Despedir',
        'app.buttons.edit': 'Editar',
        'app.buttons.save': 'Salvar',
        'app.buttons.signIn': 'Iniciar Sesión',
        'app.buttons.signOut': 'Cerrar Sesión',
        'app.buttons.signUp': 'Regístrate',
        'app.buttons.submit': 'Enviar',
        'app.confirm.areYouSure': '¿Estás seguro?',
        'app.confirm.unsavedChanges': 'Hay cambios sin guardar. ¿Estás seguro?',
        'auth.email.emailLegend': 'Correo',
        'auth.email.emailPlaceholder': 'tu@email.com',
        'auth.email.passwordForgotten': 'Olvido su contraseña?',
        'auth.email.passwordPlaceholder': 'contraseña',
        'auth.email.passwordRecoveryLegend': 'Recuperación de contraseña de correo electrónico.',
        'auth.email.recoveryEmailSent': 'Correo electrónico de recuperación ha sido enviado.',
        'auth.email.resetPassword': 'Restablecer contraseña',
        'auth.signInError.email': 'Dirección de correo no valida.',
        'auth.signInError.required':
          'Por favor llenar {prop, select, email {email} password {contraseña}}.',
        'auth.signInError.simplePassword':
          'La contraseña debe contener al menos {minLength} caracteres.',
        'auth.social.facebookSignIn': 'Iniciar sesión en Facebook',
        'firebase.error.EMAIL_TAKEN':
          'La nueva cuenta de usuario no puede ser creada porque la dirección de correo electrónico especificada ya se encuentra en uso.',
        'firebase.error.INVALID_EMAIL':
          'La dirección de correo especificada no es una dirección de correo válida.',
        'firebase.error.INVALID_PASSWORD':
          'La contraseña de la cuenta de usuario especificada no es válida.',
        'firebase.error.INVALID_USER': 'La cuenta de usuario especificada no existe.',
        'footer.madeByHtml': 'Hecho por',
        'intl.page.unreadCount': '{unreadCount, plural, one {mensaje} other {mensajes}}',
        'loading.loadingText': 'Cargando',
        'loading.longLoadingText': 'Todavía se está cargando, por favor, compruebe su conexión',
        'notFound.continue': 'Continuar aquí por favor.',
        'notFound.h1': 'Esta página no está disponible',
        'notFound.p': 'El link puede estar roto, o la página ha sido eliminada.',
        'firebase.error.auth/network-request-failed': '',
        'firebase.error.auth/too-many-requests': '',
        'firebase.error.auth/user-token-expired': '',
      },
      fr: {
        'app.buttons.add': 'Ajouter',
        'app.buttons.cancel': 'Annuler',
        'app.buttons.delete': 'Supprimer',
        'app.buttons.dismiss': 'Rejeter',
        'app.buttons.edit': 'Editer',
        'app.buttons.save': 'Enregistrer',
        'app.buttons.signIn': 'Connexion',
        'app.buttons.signOut': 'Déconnexion',
        'app.buttons.signUp': "S'inscrire",
        'app.buttons.submit': 'Envoyer',
        'app.confirm.areYouSure': 'Etes-vous sûr ?',
        'app.confirm.unsavedChanges': 'Vous avez effectué des modifications. Etes-vous sûr ?',
        'app.links.home': 'Accueil',
        'app.links.intl': 'Traduction',
        'app.links.signOut': 'Déconnexion',
        'app.links.notFound': 'Page introuvable',
        'app.links.offline': 'Hors ligne',
        'app.links.profile': 'Profil',
        'app.links.settings': 'Paramètres',
        'app.links.signIn': 'Connexion',
        'app.links.users': 'Utilisateurs',
        'app.links.guide': 'Guide',
        'auth.email.emailLegend': 'Email',
        'auth.email.emailPlaceholder': 'votre@email.com',
        'auth.email.passwordForgotten': 'Mot de passe oublié ?',
        'auth.email.passwordPlaceholder': 'mot de passe',
        'auth.email.passwordRecoveryLegend': 'Récupération de mot de passe',
        'auth.email.recoveryEmailSent': "L'email de récupération du mot de passe a été envoyé.",
        'auth.email.resetPassword': 'Réinitialiser le mot de passe',
        'auth.signInError.email': "L'adresse email n'est pas valide.",
        'auth.signInError.required':
          'Veuillez remplir le champ {prop, select, email {email} password {mot de passe}}.',
        'auth.signInError.simplePassword':
          'Le mot de passe doit contenir au moins {minLength} caractères.',
        'auth.social.facebookSignIn': 'Connexion Facebook',
        'firebase.error.EMAIL_TAKEN':
          "Le nouveau compte utilisateur ne peut pas être créé car l'email indiqué est déjà utilisé.",
        'firebase.error.INVALID_EMAIL': "L'email spécifié n'est pas valide.",
        'firebase.error.INVALID_PASSWORD':
          'Le mot de passe du compte utilisateur spécifié est incorrect.',
        'firebase.error.INVALID_USER': "Le compte utilisateur spécifié n'existe pas.",
        'footer.madeByHtml': 'Réalisé avec amour par',
        'intl.page.unreadCount': '{unreadCount, plural, one {message} other {messages}}',
        'loading.loadingText': 'Chargement',
        'loading.longLoadingText': "Chargement toujours, s'il vous plaît vérifier votre connexion",
        'notFound.continue': "Continuez ici s'il vous plaît.",
        'notFound.h1': "Cette page n'est pas disponible",
        'notFound.p': 'Le lien est peut-être périmé ou la page a été supprimée.',
        'firebase.error.auth/user-token-expired': '',
        'firebase.error.auth/too-many-requests': '',
        'firebase.error.auth/network-request-failed': '',
        'app.links.watchlist': '',
        'app.links.tv_remote': '',
        'app.links.transfers': '',
        'app.links.sports': '',
        'app.links.preferences': '',
        'app.links.pay_my_bill': '',
        'app.links.parental_controls': '',
        'app.links.on_demand': '',
        'app.links.my_purchases': '',
        'app.links.live_tv': '',
        'app.links.feedback': '',
        'app.links.dvr': '',
        'app.links.dev': '',
        'app.links.closed_captioning': '',
        'app.links.back': '',
        'app.links.authorized_devices': '',
      },
      pt: {
        'app.buttons.add': 'Adicionar',
        'app.buttons.cancel': 'Cancelar',
        'app.buttons.delete': 'Excluir',
        'app.buttons.dismiss': 'Demitir',
        'app.buttons.edit': 'Editar',
        'app.buttons.save': 'Salvar',
        'app.buttons.signIn': 'Usuário',
        'app.buttons.signOut': 'Sair',
        'app.buttons.signUp': 'Inscrever-se',
        'app.buttons.submit': 'Enviar',
        'app.confirm.areYouSure': 'Você tem certeza?',
        'app.confirm.unsavedChanges': 'Você tem alterações não salvas. Você tem certeza?',
        'app.links.home': 'Início',
        'app.links.intl': 'Idioma',
        'app.links.signOut': 'Sair',
        'app.links.notFound': 'Página não encontrada',
        'app.links.offline': 'Off-line',
        'app.links.profile': 'Perfil',
        'app.links.settings': 'Configurações',
        'app.links.signIn': 'Usuário',
        'app.links.users': 'Usuários',
        'app.links.guide': 'Guia',
        'auth.email.emailLegend': 'Email',
        'auth.email.emailPlaceholder': 'endereço@email.com',
        'auth.email.passwordForgotten': 'Esqueceu sua senha?',
        'auth.email.passwordPlaceholder': 'senha',
        'auth.email.passwordRecoveryLegend': 'Email para recuperação de senha.',
        'auth.email.recoveryEmailSent': 'Email de recuperação foi enviado.',
        'auth.email.resetPassword': 'Restaurar Senha',
        'auth.signInError.email': 'Email inválido.',
        'auth.signInError.required':
          'Favor preencher {prop, select, email {endereço de email} password {senha}}.',
        'auth.signInError.simplePassword': 'Senha precisa conter {minLength} caracteres.',
        'auth.social.facebookSignIn': 'Login do Facebook',
        'firebase.error.EMAIL_TAKEN':
          'Novo usuário não pode ser criado, o email informado já foi utilizado.',
        'firebase.error.INVALID_EMAIL': 'Email informado não é válido.',
        'firebase.error.INVALID_PASSWORD': 'A senha do usuário específico está incorreta.',
        'firebase.error.INVALID_USER': 'Usuário especificado não existe.',
        'footer.madeByHtml': 'desenvolvido por',
        'intl.page.unreadCount': '{unreadCount, plural, one {mensagem} other {mensagens}}',
        'loading.loadingText': 'Carregando',
        'loading.longLoadingText': 'Ainda a carregar, por favor, verifique sua conexão',
        'notFound.continue': 'Por favor, continue aqui.',
        'notFound.h1': 'A página não está disponível',
        'notFound.p': 'O link está indisponível ou a página foi removida.',
        'app.links.authorized_devices': '',
        'app.links.back': '',
        'app.links.closed_captioning': '',
        'app.links.dev': '',
        'app.links.dvr': '',
        'app.links.feedback': '',
        'app.links.live_tv': '',
        'app.links.my_purchases': '',
        'app.links.on_demand': '',
        'app.links.parental_controls': '',
        'app.links.pay_my_bill': '',
        'app.links.preferences': '',
        'app.links.sports': '',
        'app.links.transfers': '',
        'app.links.tv_remote': '',
        'app.links.watchlist': '',
        'firebase.error.auth/network-request-failed': '',
        'firebase.error.auth/too-many-requests': '',
        'firebase.error.auth/user-token-expired': '',
      },
      ro: {
        'app.links.dev': 'Розробник',
        'app.links.preferences': 'Налаштування',
        'app.links.back': 'Назад',
        'app.links.home': 'Acasă',
        'app.links.guide': 'Ghid',
        'app.links.watchlist': 'Мій список',
        'app.links.dvr': 'Відеореєстратор',
        'app.links.on_demand': 'Відео за запитом',
        'app.links.my_purchases': 'Мої покупки',
        'app.links.sports': 'Спорт',
        'app.links.live_tv': 'Жива телевізія',
        'app.links.transfers': 'Трансфери',
        'app.links.tv_remote': 'Віддалений телевізор',
        'app.links.signIn': 'Увійти',
        'app.links.signOut': 'Deconectare',
        'app.links.pay_my_bill': 'Заплати мой законопроект',
        'app.links.parental_controls': 'Батьківський контроль',
        'app.links.authorized_devices': 'Авторизовані пристрої',
        'app.links.closed_captioning': 'Закрите підпис',
        'app.links.feedback': 'Коментарі',
        'app.links.notFound': 'Pagina nu poate fi găsită',
        'app.links.intl': 'Traducere',
        'app.links.users': 'Utilizatori',
        'app.links.offline': 'Deconectat',
        'app.links.profile': 'Profil',
        'app.links.settings': 'Parametri',
        'app.buttons.add': 'Adăuga',
        'app.buttons.cancel': 'Anulare',
        'app.buttons.delete': 'Șterge',
        'app.buttons.dismiss': 'Destitui',
        'app.buttons.edit': 'Editați',
        'app.buttons.save': 'Salvați',
        'app.buttons.signIn': 'Autentificare',
        'app.buttons.signOut': 'Deconectare',
        'app.buttons.signUp': 'Inscrie-te',
        'app.buttons.submit': 'A depune',
        'app.confirm.areYouSure': 'Esti sigur?',
        'app.confirm.unsavedChanges': 'Ai modificări nesalvate. Esti sigur?',
        'auth.email.emailLegend': 'E-mail',
        'auth.email.emailPlaceholder': 'altău@email.com',
        'auth.email.passwordForgotten': 'Ai uitat parola?',
        'auth.email.passwordPlaceholder': 'Parolă',
        'auth.email.passwordRecoveryLegend': 'Recuperarea parolei de email',
        'auth.email.recoveryEmailSent': 'Emailul de recuperare a fost trimis.',
        'auth.email.resetPassword': 'Resetează parola',
        'auth.signInError.email': 'Adresa e-mail nu este validă.',
        'auth.signInError.required':
          'Completați câmpurile {prop, select, email {email} password {parolă}}.',
        'auth.signInError.simplePassword':
          'Parola trebuie să conține cel puțin {minLength} caractere.',
        'auth.social.facebookSignIn': 'Logare Facebook',
        'firebase.error.EMAIL_TAKEN':
          'Noul cont de utilizator nu poate fi creat, deoarece adresa de email specificată este deja în uz.',
        'firebase.error.INVALID_EMAIL': 'Emailul specificat nu este un email valid.',
        'firebase.error.INVALID_PASSWORD':
          'Parola specificată contului de utilizator este incorectă.',
        'firebase.error.INVALID_USER': 'Contul de utilizator specificat nu există.',
        'footer.madeByHtml': 'realizat de',
        'intl.page.unreadCount': '{unreadCount, plural, one {mesaj} other {mesaje}}',
        'loading.loadingText': 'Se incarca',
        'loading.longLoadingText': 'Încă se încarcă, vă rugăm să verificați conexiunea',
        'notFound.continue': 'Continuați aici, vă rog.',
        'notFound.h1': 'Această pagină nu este disponibilă',
        'notFound.p': 'S-ar putea că linkul a fost vechi sau că pagina a fost ștearsă.',
        'firebase.error.auth/network-request-failed': '',
        'firebase.error.auth/too-many-requests': '',
        'firebase.error.auth/user-token-expired': '',
      },
    },
  },
  onDemand: {
    carousels: {
      fetching: false,
      error: false,
      content: [],
    },
    list: {
      fetching: false,
      error: false,
      content: {
        items: [],
        filters: {},
        sorts: [],
        count: -1,
        startingLetters: {},
        totalCount: -1,
      },
    },
    currentFilters: null,
    letter: '',
    whatsHot: {
      fetching: false,
      error: false,
      content: [],
      requestId: 0,
    },
  },
  network: {
    content: {
      fetching: false,
      error: false,
      items: {},
      counts: {},
    },
    network: {
      fetching: false,
      error: false,
      details: null,
    },
    categories: {
      fetching: false,
      error: false,
      items: [],
    },
    currentFilters: undefined,
  },
  networks: {
    fetching: false,
    error: false,
    content: [],
  },
  users: {
    online: null,
  },
  sports: {
    games: {
      shelves: {
        'ALL SPORTS': [],
      },
      rawGames: [],
      fetching: false,
      error: false,
    },
    myTeams: {
      teamIds: [],
      games: [],
      teams: [],
      fetching: false,
      error: false,
    },
    allTeams: {
      teamsByLeague: {},
      teamsById: {},
      fetching: false,
      error: false,
    },
    leagues: {
      fetching: false,
      items: [],
      error: false,
    },
    saveTeams: {
      fetching: false,
      error: false,
    },
    gameStats: {
      error: false,
      fetching: false,
      stats: {},
    },
    currentFilters: {
      day: 'Today',
      sport: 'ALL SPORTS',
      shelfFilters: {},
    },
  },
  team: {
    teamInfo: {
      info: null,
      fetching: false,
      error: false,
    },
    teamSchedule: {
      fetching: false,
      teamSchedule: [],
      error: false,
    },
    teamStandings: {
      fetching: false,
      teamStandings: {},
      error: false,
    },
    opponentInfo: {
      info: null,
      fetching: false,
      error: false,
    },
    upcomingGames: {
      fetching: false,
      error: false,
      content: [],
    },
    gamesInfo: {
      games: [],
      fetching: false,
      error: false,
    },
  },
  search: {
    searchKeyWord: '',
    airings: {
      totalCount: null,
      pagesAmount: null,
      pages: [],
      searchKeyWord: '',
    },
    moviesAndShows: {
      totalCount: null,
      pagesAmount: null,
      pages: [],
      searchKeyWord: '',
    },
    dvrs: {
      totalCount: null,
      pagesAmount: null,
      pages: [],
      searchKeyWord: '',
    },
    autoComplete: {
      completions: [],
      completionToken: 0,
      fetching: false,
      error: false,
    },
    recentSearches: [],
  },
  profiles: {
    content: {
      profiles: [],
      passcode: {
        requirePasscode: false,
        fetching: false,
        error: false,
      },
    },
    hidden: false,
    mode: '',
    id: '',
    /*
   * Profile that is passed to the ProfileForm component for edit one on web only
   */
    updateProfileOnWeb: {
      profile: null,
    },
    profileAvatars: {
      profileList: [],
      fetching: false,
    },
    download: {
      fetching: false,
      error: false,
    },
    delete: {
      profileId: '',
      fetching: false,
      error: false,
    },
    create: {
      profile: null,
      fetching: false,
      error: false,
    },
    update: {
      profile: null,
      fetching: false,
      error: false,
    },
    isPasscodeSet: {
      fetching: false,
      error: false,
      isPasscodeSet: false,
    },
    isSecurityQuestionSet: {
      fetching: false,
      error: false,
      isSecurityQuestionSet: false,
    },
    parentalControlRatings: {
      getFetching: false,
      getError: false,
      setFetching: false,
      setError: false,
      movieRatings: [],
      showRatings: [],
      passcode: '',
    },
    currentProfile: {
      profile: undefined,
      fetching: false,
      error: false,
      profileId: undefined,
      role: '',
      ageLevel: '',
    },
    profileModalRequired: false,
  },
  profilesSecurity: {
    questions: {
      securityQuestions: [],
      currentQuestion: '',
      error: false,
      fetching: false,
    },
    passcode: {
      fetching: false,
      error: false,
    },
  },
  home: {
    promos: {
      fetching: false,
      error: false,
      content: [],
      requestId: 0,
    },
    recommendations: {
      fetching: false,
      error: false,
      content: [],
      requestId: 0,
    },
    most_popular: {
      fetching: false,
      error: false,
      content: [],
      requestId: 0,
    },
    recently_watched: {
      fetching: false,
      error: false,
      content: [],
      requestId: 0,
    },
    live_channels: {
      fetching: false,
      error: false,
      content: [],
      requestId: 0,
    },
    view_all: {
      fetching: false,
      error: false,
      content: [],
      requestId: 0,
    },
  },
  watchlist: {
    list: {
      fetching: false,
      error: false,
      content: [],
    },
    sort: 'date_added',
    contentIdsIncludedToWatchlist: {},
    watchlistIsStale: false,
    mappingWasInitialized: true,
  },
  player: {
    airings: [],
    airingsMap: {},
    changeReceiverError: false,
    changeReceiverFetching: false,
    channel: undefined,
    channelInfo: undefined,
    connectionMode: undefined,
    containerOpen: false,
    contentId: undefined,
    debugVisible: false,
    dvrId: undefined,
    dvrProgress: undefined,
    error: false,
    fetching: false,
    listing: {},
    metadata: {},
    customAttributesMap: {},
    miniPlayer: false,
    recentVideoId: null,
    recentlyWatchedProgress: null,
    nextQvtPayload: {},
    playbackCouldNotBeStarted: false,
    postToRecentsError: {},
    programInfo: null,
    playerType: undefined,
    playerVisible: false,
    playerErrorCode: undefined,
    playerErrorResponseText: undefined,
    playerErrorResponseCode: undefined,
    playerErrorType: undefined,
    playerErrorName: undefined,
    playerErrorServerResponse: undefined,
    putToRecentsError: {},
    putToRecentsFinished: false,
    isNativePlayerInFullscreen: false,
    qvtPayload: {},
    qvtDate: undefined,
    resumePlayback: false,
    isSeeking: false,
    slingPlaybackInfo: {},
    slingPlayerConnected: false,
    slingPlayerError: false,
    slingPlayerErrorReason: undefined,
    slingPlayerErrorMessage: undefined,
    slingPlayerErrorType: undefined,
    slingPlayerErrorCode: undefined,
    slingPlayerErrorObject: undefined,
    slingPlayerEventObject: undefined,
    slingPlayerLoading: false,
    slingPlayerPlaying: false,
    slingPlayerLocalStorage: {},
    slingProgress: null,
    slingErrors: {
      errors: {
        2050: [],
        2052: [],
        2014: [],
        2009: [],
        2025: [],
        2040: [],
        2008: [],
        all: [],
      },
    },
    slingSessionActive: false,
    sourceType: undefined,
    stream: undefined,
    asyncPopupInfo: undefined,
    tunersPopupInfo: undefined,
    unsupportedReceiverModalOpen: false,
    unsupportedReceiverReason: '',
    playerStreamId: undefined,
    mostRecentlyWatchedProgress: {},
    bingeWatching: {
      isBingeWatchingCanceled: false,
      messageData: undefined,
      isNextBingeEpisodeLoading: false,
    },
    playerEventObject: undefined,
    recentsProgress: {
      isRequestInProgress: false,
      progress: 0,
    },
  },
  feedback: {
    sendingFeedback: false,
    errorSendingFeedback: false,
    feedback: {
      userComment: '',
      email: '',
    },
  },
  preferences: {
    accountPreferences: {
      fetching: false,
      error: false,
      preferences: undefined,
    },
    profilePreferences: {
      fetching: false,
      error: false,
      preferences: undefined,
    },
    dynaDevices: {
      fetching: false,
      error: false,
      devices: [],
    },
    legacyDevices: {
      fetching: false,
      error: false,
      devices: [],
    },
    removeDevice: {
      currentlyRemovingDevices: [],
      errorDescription: '',
    },
    gameFinderPreferences: {
      showScores: undefined,
      fetching: false,
      errorFetching: false,
      errorSaving: true,
    },
    guidePreferences: undefined,
    timerPreferences: {
      fetching: false,
      errorFetching: false,
      errorSaving: false,
      preferences: undefined,
    },
  },
};

export { initialState };
